<div class="acreditacion-container dark-gray-panel" id="acreditacion" #rootElement>
    <div class="container">
        <div [innerHTML]="tituloAcreditacion">
        </div>
        <div class="row mt-3">
            <div class="col-3">
                <img src="https://api.bealign.com/img/contenidos/21.jpg" class="img-fluid">
            </div>
            <div class="col-3">
                <img src="https://api.bealign.com/img/contenidos/22.jpg" class="img-fluid">
            </div>
            <div class="col-3">
                <img src="https://api.bealign.com/img/contenidos/23.jpg" class="img-fluid">
            </div>
            <div class="col-3">
                <img src="https://api.bealign.com/img/contenidos/24.jpg" class="img-fluid">
            </div>
        </div>
        <div class="mt-3" [innerHTML]="subtituloAcreditacion">
            
        </div>
    </div>
</div>
<app-acreditacion-registro></app-acreditacion-registro>